import {GET_SERVICE_LIST} from "./serviceTypes";

export default {
  [GET_SERVICE_LIST](state, data) {
    if(data.items && data.items.length) {
      for(let i = 0; i < data.items.length; i++) {
        if(data.items[i].type == 'gift_card' || data.items[i].type == 'custom') {
          data.items.splice(i, 1);
        }
      }
    }
    state.serviceList = data;
  },
}
